<template>
  <el-main>
    <el-tabs id="syslog-tabs" v-model="activeName" type="card">
      <el-tab-pane label="街道工作统计" name="first">
        <div class="tool" shadow="never" style="display: flex">
          <el-date-picker
            v-model="currentMonth"
            type="month"
            placeholder="选择年月"
            format="yyyy年MM月"
            value-format="yyyy-MM"
            style="margin-left: 30px"
            :clearable="false"
            size="mini"
            @change="handleDateChange"
          >
          </el-date-picker>
          <div style="flex: 1"></div>
          <el-button
            type="warning"
            icon="el-icon-download"
            size="mini"
            @click="handleExport"
            >导出</el-button
          >
        </div>
        <div class="table-wrapper" style="flex-direction: column">
          <el-table
            v-loading="loading"
            element-loading-text="拼命加载中"
            :data="operatorLogs"
            border
            style="width: 100%"
            height="100%"
            size="small"
          >
            <el-table-column
              prop="orgname"
              label="机构名称"
              align="center"
              width="350"
            ></el-table-column>

            <el-table-column
              prop="name"
              label="操作员"
              align="center"
              width="300"
            ></el-table-column>
            <el-table-column
              prop="itemname"
              label="填报项目"
              align="center"
              width="250"
            ></el-table-column>
            <el-table-column
              prop="total"
              label="填报条数"
              align="center"
              width="200"
            ></el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="系统操作日志" name="second">
        <div class="table-wrapper" style="flex-direction: column">
          <el-table
            v-loading="loading"
            element-loading-text="拼命加载中"
            :data="tableData"
            border
            style="width: 100%"
            height="100%"
            size="small"
          >
            <el-table-column
              prop="username"
              label="用户名"
              align="center"
              width="220"
            ></el-table-column>

            <el-table-column
              prop="operation"
              label="操作"
              align="center"
              width="200"
            ></el-table-column>
            <!-- <el-table-column
          prop="method"
          label="方法名"
          align="center"
          width="450"
        ></el-table-column> -->
            <el-table-column
              prop="ip"
              label="IP地址"
              align="center"
              width="250"
            ></el-table-column>
            <el-table-column
              prop="createdate"
              label="时间"
              align="center"
              width="300"
            ></el-table-column>
          </el-table>

          <div class="pagination">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-sizes="[20, 35, 50, 100]"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </el-main>
</template>

<script>
import {
  exportExcel
} from "@/utils/exportTable.js";
export default {
  name: "SysLog",

  data() {
    return {
      loading: false,
      sysLogInfo: [],
      currentPage: 1,
      pagesize: 20,

      activeName: "first",
      currentMonth: "",
      operatorLogs:[]
     
    };
  },
  mounted() {
    var date = new Date();
    var seperator1 = "-";
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    this.currentMonth = year + seperator1 + month;

    this.getOperatorLog();
    this.getSysLogData();
  },

  computed: {
    total() {
      return this.sysLogInfo.length;
    },
    tableData() {
      return this.sysLogInfo.slice(
        (this.currentPage - 1) * this.pagesize,
        this.currentPage * this.pagesize
      );
    },
  },

  methods: {
    // 初始化系统日志数据
    getSysLogData() {
      this.loading = true;
      this.$axios
        .get("/syslog")
        .then((response) => {
          const { data } = response;
          this.sysLogInfo = data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    handleSizeChange(val) {
      this.pagesize = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },


    getOperatorLog(){
      this.loading = true;
      this.operatorLogs=[];
      this.$axios
        .get("/syslog/getOperatorLog/"+this.currentMonth)
        .then((response) => {
          const { data } = response;
          this.operatorLogs = data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    handleDateChange() {
      this.getOperatorLog();
    },

      // 导出记录表单
      handleExport() {
      const tHeader = ["机构名称","操作员","填报项目","填报条数"];
      const filterVal = ["orgname","name","itemname","total"];

      exportExcel(tHeader, filterVal, this.currentMonth+"服务填报", this.operatorLogs);
    },
  },
};
</script>

<style lang="scss">
#syslog-tabs {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .el-tabs__content {
    flex: 1;
    display: flex;
    flex-direction: column;
    .el-tab-pane {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding-bottom: 1.25rem;
      overflow-y: auto;
    }
  }
}
</style>
